export default __webpack_public_path__ + "static/media/1.a07cff27.png";